import { InsiderFunctionAndReasonDto, InsiderFunctionAndReasonSaveDto } from 'types/matter-insider-list';
import { portalAPI } from './portalAPI';

const APIInsiderFunctionAndReasonsSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['InsiderFunctionAndReasons'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getInsiderFunctionAndReasons: builder.query<InsiderFunctionAndReasonDto[], void>({
                query: () => '/v1/insider-function-and-reasons',
                providesTags: ['InsiderFunctionAndReasons'],
            }),
            addInsiderFunctionAndReason: builder.mutation<InsiderFunctionAndReasonDto, InsiderFunctionAndReasonSaveDto>(
                {
                    query: (body) => ({ url: '/v1/insider-function-and-reasons', method: 'POST', body }),
                    invalidatesTags: ['InsiderFunctionAndReasons'],
                }
            ),
            updateInsiderFunctionAndReason: builder.mutation<
                InsiderFunctionAndReasonDto,
                { id: number } & InsiderFunctionAndReasonSaveDto
            >({
                query: ({ id, ...body }) => ({ url: `/v1/insider-function-and-reasons/${id}`, method: 'PUT', body }),
                invalidatesTags: ['InsiderFunctionAndReasons'],
            }),
            deleteInsiderFunctionAndReason: builder.mutation<void, number>({
                query: (id) => ({ url: `/v1/insider-function-and-reasons/${id}`, method: 'DELETE' }),
                invalidatesTags: ['InsiderFunctionAndReasons'],
            }),
        }),
        overrideExisting: false,
    });

export const {
    useGetInsiderFunctionAndReasonsQuery,
    useAddInsiderFunctionAndReasonMutation,
    useUpdateInsiderFunctionAndReasonMutation,
    useDeleteInsiderFunctionAndReasonMutation,
} = APIInsiderFunctionAndReasonsSlice;
